import { css } from 'styled-components';

export default css`
  display: flex;
  align-items: center;
  background: ${props => props.theme.filter.background};
  padding: ${props => props.theme.space(4)};
  color: ${props => props.theme.filter.color};
  border: ${props => props.theme.filter.checkbox.border};
  border-radius: 4px;
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(16)};
  height: 50px;
  box-shadow: 0px 1px 2px 0px #00000014;
`;
